import { render, staticRenderFns } from "./PerAssignee.vue?vue&type=template&id=04d9f152&"
import script from "./PerAssignee.vue?vue&type=script&lang=js&"
export * from "./PerAssignee.vue?vue&type=script&lang=js&"
import style0 from "./PerAssignee.vue?vue&type=style&index=0&id=04d9f152&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports